export class Company {
    constructor(
        public id: string,
        public name: string | null,
    ){}
}